import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { subventionService } from "@/features/subventions/services/subvention.service";
import type { ChequesData } from "@/features/subventions/types/subsidy-sumup.types";
import type { SubsidiesResponse } from "@/features/subventions/types/subvention.types";

export const SUBSIDIES_QUERY_KEY = ["subsidies"];

// Keep old key for backwards compatibility during transition
export const SUBVENTIONS_QUERY_KEY = SUBSIDIES_QUERY_KEY;

export type UseSubsidiesResult = {
  data: SubsidiesResponse | undefined
  cheques: ChequesData | null
  isLoading: boolean
  isError: boolean
  error: Error | null
  refetch: () => void
};

export const useSubventions = (): UseSubsidiesResult => {
  const query = useQuery({
    queryKey: SUBSIDIES_QUERY_KEY,
    queryFn: subventionService.getSubsidies,
  });

  const {
    data, isLoading, isError, error, refetch,
  } = query;

  const cheques = useMemo((): ChequesData | null => {
    if (!data?.cheques?.enabled) return null;
    return data.cheques;
  }, [data]);

  return {
    data,
    cheques,
    isLoading,
    isError,
    error: error,
    refetch: () => { void refetch(); },
  };
};
